import { render, staticRenderFns } from "./MobileAuthorization.vue?vue&type=template&id=58c08fee&scoped=true"
import script from "./MobileAuthorization.vue?vue&type=script&lang=js"
export * from "./MobileAuthorization.vue?vue&type=script&lang=js"
import style0 from "./MobileAuthorization.vue?vue&type=style&index=0&id=58c08fee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c08fee",
  null
  
)

export default component.exports